var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.referenzenList.length > 0
    ? _c(
        "div",
        { staticClass: "referenzen-container" },
        [
          _c("div", { staticClass: "h2 heading" }, [_vm._v("Referenzen")]),
          _vm._v(" "),
          _vm._l(_vm.referenzenList, function(referenzen, referenzenIndex) {
            return _c("div", { key: referenzenIndex }, [
              referenzen["text"] || referenzen["ref"]
                ? _c("div", { staticClass: "referenzen" }, [
                    _c("sup", {
                      staticClass: "ref-index",
                      domProps: { innerHTML: _vm._s(referenzen["index"]) }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "ref-text d-inline",
                      domProps: { innerHTML: _vm._s(referenzen["text"]) }
                    }),
                    _vm._v(" "),
                    referenzen["ref"]
                      ? _c("div", {
                          staticClass: "ref-url d-inline",
                          domProps: {
                            innerHTML: _vm._s(
                              "<img width='20px' src='/img/right-arrow_e73e51.png'>" +
                                _vm.stringToLink(referenzen["ref"])
                            )
                          }
                        })
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-525f14be", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-525f14be","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/ReferenzComponent.vue
// module id = 604
// module chunks = 0